function addClassesToRow(elements, elementsInGrid, elementsInOneRow, className) {
  elements.forEach(el => {
    const index = el.closest('li').dataset.index;

    if (index !== -1) {
      const rowStart = Math.floor(index / elementsInOneRow) * elementsInOneRow;
      const rowEnd = rowStart + elementsInOneRow;

      for (let i = rowStart; i < rowEnd; i++) {
        if (i !== index && elementsInGrid[i]) {
          elementsInGrid[i].classList.add(className);
        }
      }
    }
  });
}

const gridContainer = document.querySelector('.main-products-grid__results ul.grid');
const elementsInGrid = gridContainer.querySelectorAll('li');
const containerWidth = gridContainer.offsetWidth;
const elementWidth = elementsInGrid[0].offsetWidth;
const elementsInOneRow = Math.floor(containerWidth / elementWidth);
const priceFromElements = gridContainer.querySelectorAll('.price__current .price__from');
const inventoryElements = gridContainer.querySelectorAll('.card__info-second .product-inventory__status:not(:empty)');

for (let i = 0; i < elementsInGrid.length; i++) {
  elementsInGrid[i].dataset.index = i;
}

// addClassesToRow(priceFromElements, elementsInGrid, elementsInOneRow, 'active_price_from');
addClassesToRow(inventoryElements, elementsInGrid, elementsInOneRow, 'active');